import { render, staticRenderFns } from "./SxMaterialView.vue?vue&type=template&id=69bd15aa&"
import script from "./SxMaterialView.vue?vue&type=script&lang=js&"
export * from "./SxMaterialView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports